class TrustBarMarquee {
  static SCROLL_SPEED = 45;

  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-trust-bar-track]');
    if (!this.track) return;

    this.setup = this.setup.bind(this);
    this.setup();
    document.fonts?.ready?.then(this.setup);

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(this.setup);
      observer.observe(this.root);
    }
  }

  setup() {
    const groups = [...this.track.querySelectorAll('.trust-bar__group')];
    const firstGroup = groups[0];
    if (!firstGroup) return;

    groups.slice(2).forEach((group) => group.remove());

    const viewportWidth = this.root.offsetWidth;
    while (this.track.scrollWidth < viewportWidth * 2) {
      const clone = firstGroup.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      this.track.appendChild(clone);
    }

    const segmentWidth = firstGroup.offsetWidth;
    if (!segmentWidth) return;

    const duration = segmentWidth / TrustBarMarquee.SCROLL_SPEED;
    this.track.style.setProperty('--tb-scroll-distance', `${-segmentWidth}px`);
    this.track.style.setProperty('--tb-scroll-duration', `${duration}s`);
  }
}

document.querySelectorAll('.trust-bar').forEach((root) => new TrustBarMarquee(root));
